<template>
  <div style="width: 100%; overflow-x: hidden;">
    <span style="margin-bottom: 10px; display: block">Kết quả bài test</span>
    <div class="result-wrapper" v-loading="loading">
      <template v-if="hasResultContent">
        <div v-for="result in resultTests" :key="result.key" class="result">
          <div class="result__header">
            <div class="result__title">
              <i :class="result.icon" class="result__icon"></i>
              <span>{{ result.name }}</span>
            </div>
            <span>Số điểm: <span class="result__score">{{ result.score }}</span> /9.0</span>
          </div>
          <div class="result__body">
            <div v-if="result.key !== 'vocabulary_and_grammar'" class="result__label">Nhận xét:</div>
            <p v-if="result.totalQuestions" class="mb-0">
              Học viên đúng {{ result.correctCount }}/{{ result.totalQuestions }} câu trong kỹ năng này
            </p>
            <p v-else class="mb-0">
              Học viên đọc phần nhận xét chi tiết để hiểu rõ những tiêu chí của kĩ năng này
            </p>
            <el-collapse v-if="result.comments.length > 0" class="mt-2">
              <el-collapse-item title="Xem chi tiết" name="1">
                <div v-for="(comment, index) in result.comments" :key="index" class="result__comment">
                  <div class="result__label">Tiêu chí {{ index + 1 }}: {{ comment.name }}</div>
                  <p class="pre-line">{{ comment.autoComment }}</p>
                  <div v-if="comment.detail" class="result__label">Chi tiết:</div>
                  <p class="pre-line">{{ comment.detail }}</p>
                  <hr>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>

        <div v-if="hasOverallScore" class="result">
          <div class="result__header">
            <div class="result__title">
              <i class="el-icon-s-data result__icon"></i>
              <span>Overall</span>
            </div>
            <span>Số điểm: <span class="result__score">{{ overallScore }}</span> /9.0</span>
          </div>
        </div>

        <div v-if="exam.recommended_course_name">
          <span class="course-title">Khóa học gợi ý</span>
          <div class="result course">{{ exam.recommended_course_name }}</div>
        </div>

        <div v-if="exam.supplementary_course_name">
          <span class="course-title">Khóa học bổ sung</span>
          <div class="result course">{{ exam.supplementary_course_name }}</div>
        </div>
      </template>
      <div v-else-if="!loading">Chưa có kết quả.</div>
    </div>
  </div>
</template>

<script>
import {GET_RESULT_ENTRANCE_EXAM} from "@/core/services/store/marking/marking.module";

const SKILLS = [
  {key: "vocabulary_and_grammar", name: "Vocabulary and Grammar", icon: "el-icon-reading"},
  {key: "speaking", name: "Speaking", icon: "el-icon-mic"},
  {key: "listening", name: "Listening", icon: "el-icon-headset"},
  {key: "reading", name: "Reading", icon: "el-icon-document"},
  {key: "writing", name: "Writing", icon: "el-icon-edit-outline"},
]

export default {
  name: 'ResultTestEntrance',
  props: {
    markingExamRetakeId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      exam: {},
    }
  },
  computed: {
    resultTests() {
      return SKILLS.map(skill => this.makeResult(skill)).filter(result => result !== null)
    },
    hasOverallScore() {
      return this.exam.avg_score !== null && this.exam.avg_score !== undefined
    },
    overallScore() {
      return this.formatScore(this.exam.avg_score)
    },
    hasResultContent() {
      return this.resultTests.length > 0 || this.hasOverallScore
    },
  },
  methods: {
    getResult() {
      this.loading = true
      this.$store.dispatch(GET_RESULT_ENTRANCE_EXAM, {marking_exam_retake_id: this.markingExamRetakeId}).then(res => {
        this.exam = (!res.error && res.data) || {}
      }).catch(() => {
        this.exam = {}
      }).finally(() => this.loading = false)
    },
    makeResult(skill) {
      const data = this.exam[skill.key]
      if (!data || data.score === null || data.score === undefined || data.score === "") {
        return null
      }
      return {
        key: skill.key,
        name: skill.name,
        icon: skill.icon,
        score: this.formatScore(data.score),
        correctCount: data.correct_count || 0,
        totalQuestions: data.total_questions || 0,
        comments: this.extractComments(data.score_data),
      }
    },
    extractComments(scoreData) {
      const teacherMarks = Array.isArray(scoreData)
          ? scoreData.flatMap(item => item?.teacher_marks || [])
          : scoreData?.teacher_marks || []

      return teacherMarks.map(mark => ({
        name: mark.label_parent || mark.label || mark.key_parent || mark.key || "",
        autoComment: this.normalizeComment(mark.comment_auto),
        detail: this.normalizeComment(mark.comment_detail),
      }))
    },
    formatScore(score) {
      if (score === null || score === undefined || score === "") {
        return "0.0"
      }
      return Number(score).toFixed(1)
    },
    normalizeComment(value) {
      return (value || "").replace(/<br\s*\/?>/gi, "\n")
    },
  },
  mounted() {
    this.getResult()
  },
}
</script>

<style scoped>
.result-wrapper {
  background: #F6F6F6;
  padding: 20px 15px;
  border-radius: 5px;
  position: relative;
  min-height: 80px;
  max-height: 750px;
  overflow-y: auto;
}
.result {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  background: white;
  border: 1px solid lightgray;
  margin-bottom: 10px;
}
.result__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.result__title {
  display: flex;
  align-items: center;
  gap: 5px;
}
.result__icon {
  background: lightskyblue;
  display: block;
  color: white;
  padding: 4px;
  border-radius: 9999px;
}
.result__score {
  font-weight: 600;
}
.result__body {
  margin-top: 10px;
}
.result__label {
  font-weight: 600;
  margin-bottom: 4px;
}
.result__comment {
  text-align: left;
}
.pre-line {
  white-space: pre-line;
}
.course-title {
  display: block;
  margin-bottom: 6px;
}
.course {
  font-weight: 500;
  padding: 16px;
}
</style>
